import _ from 'lodash';
import { Injectable } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { MdbModalWrapperService } from 'app/core/services/mdb-modal-wrapper.service';
import { ImportInKindItemsComponent } from '../components/import-in-kind-items/import-in-kind-items.component';
import { tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { LoadingService } from 'app/core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class ImportInKindItemsService {
  public modalRef: MdbModalRef<any> | null = null;

  constructor(
    private modalService: MdbModalWrapperService,
    private http: HttpClient,
    private cookieService: CookieService,
    private loadingService: LoadingService,
  ) { }

  open(data: any, callback?: () => void) {
    if(this.modalRef) {
      return this.modalRef;
    }

    this.modalRef = this.modalService.open(ImportInKindItemsComponent, {
      ignoreBackdropClick: false,
      containerClass:'mdb-modal-backdrop-paybee modal fade show',
      modalClass:'modal-dialog modal-xl',
      data: { ...data, callback }
    });    

    return this.modalRef;
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  getCampaignDonations(params) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/campaignDonations', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));        
  }
   
}
